import * as React from "react";
import {
  makeStyles,
  Image,
  Text,
  Button,
} from "@fluentui/react-components";

// Define brand color
const brandColor = "#921784";

// --- Styles ---
const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    minHeight: "calc(100vh - 60px)",
    padding: "20px",
    boxSizing: "border-box",
    gap: "24px",
  },
  logo: {
    width: "180px",
    height: "auto",
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
    color: brandColor,
  },
  description: {
    fontSize: "14px",
    color: "#3b3a39",
    maxWidth: "300px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "80%",
    maxWidth: "250px",
    gap: "12px",
  },
});

// --- Props Interface ---
export interface WelcomeScreenProps {
  onLoginClick: () => void;
  onMoreInfoClick: () => void;
}

// --- Component WelcomeScreen ---
const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  onLoginClick,
  onMoreInfoClick
}) => {
  const styles = useStyles();

  const handleLogin = () => {
    onLoginClick();
  };

  const handleMoreInfo = () => {
    onMoreInfoClick();
  };

  return (
    <div className={styles.container}>
      <Image className={styles.logo} src="/assets/lexfania-logo.svg" alt="Logo de Lexfania" />

      <Text as="h1" className={styles.title}>
        ¡Bienvenido a Lexfania!
      </Text>

      <Text className={styles.description}>
        Tu asistente legal con Inteligencia Artificial. Analiza documentos, responde dudas y agiliza tu trabajo directamente en Office.
      </Text>

      <div className={styles.buttonContainer}>
        <Button appearance="primary" size="large" onClick={handleLogin}>
          Iniciar Sesión
        </Button>
        <Button appearance="outline" size="large" onClick={handleMoreInfo}>
           Más Información
         </Button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
